import {
  Adsterra,
  Assist,
  Dv360,
  Exo,
  Facebook,
  GTM,
  RedTrack,
  Tiktok,
  Affiliate,
} from './channel';

import Cookies from 'js-cookie';
import { Hash } from '../commonLib/Hash';
import { TopcoPartner } from './TopcoPartner';
import UserDefault from '../user/UserDefault';
import { UserInfoType } from '../user/types/UserSeesionType';
import { UserSession } from '../user/UserSession';
import { getMarketingLoginCheckTime } from '../utils/timeUtils';

export namespace Marketing {
  export interface SetParamsType {
    payCnt?: number;
    // 결제정보
    purchase?: {
      id?: string;
      value?: number | string;
      currency?: string;
      transaction_id?: string;
      count?: number;
    };
    comicId?: number;
    episodeId?: number;
    loginId?: string;
    userId?: number;
    method?: string; // 일반 가입 -> '일반회원가입', 파트너 코드 유입 -> p_id
    category?: string; // 열람 카테고리
    productIds?: number[]; // 열람 카테고리 상위 만화
  }
  const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';
  export const setter = (event: GTM.EVENT, params?: SetParamsType) => {
    if (!isProduction) return;
    const userInfo = UserSession.getUserInfo();
    const eventId = GTM.getEventId(); // sentToFbca와 gtm에 보내는 값이 동일해야함
    const externalId = Hash.getHash(userInfo.userId.toString()); // sentToFbca와 gtm에 보내는 값이 동일해야함

    GTM.send({
      event,
      params,
      eventId,
      externalId,
      userInfo,
    });
    Facebook.send({
      event,
      params,
      eventId,
      externalId,
      userInfo,
    });
  };

  export const setLoginJoin = async (
    isJoin: boolean,
    user: UserInfoType,
    method?: string, // 일반 가입 -> '일반회원가입', 파트너 코드 유입 -> p_id
  ) => {
    // 회원가입
    if (isJoin) {
      const params: SetParamsType = {
        loginId: user.loginId ?? '',
        userId: user.userId ?? 0,
        method,
      };

      if (TopcoPartner.isTestPartnerCode()) {
        // 특정 pid 가입완료 후, 결제창 노출 setter
        UserDefault.AfterJoinOpenPaymentModalFlag.setter();
      }

      setter(GTM.EVENT.JOIN, params);

      // Adsterra
      await Adsterra.sendApi(GTM.EVENT.JOIN);
      // dv360
      await Dv360.sendApi(GTM.EVENT.JOIN);
      //tiktok
      await Tiktok.sendApi(GTM.EVENT.JOIN, params);
      //exo
      await Exo.sendApi(GTM.EVENT.JOIN);
      //assist
      await Assist.sendApi(GTM.EVENT.JOIN);
      //redtrack
      await RedTrack.sendApi(GTM.EVENT.JOIN);
      // affiliate
      await Affiliate.sendApi(GTM.EVENT.JOIN, params);
      return;
    }

    // 로그인 - 1일 1회 제한
    const result = login.check(user.loginId);
    if (!result) {
      setter(GTM.EVENT.LOGIN);
    }
  };

  export const setPurchaceComplete = async () => {
    try {
      const payInfo = UserDefault.gtmPayInfo.getter();
      const userInfo = UserSession.getUserInfo();
      if (payInfo) {
        setter(GTM.EVENT.PURCHACE_COMPLETE_MODAL, {
          purchase: {
            id: payInfo.id,
            value: payInfo.value,
            currency: payInfo.currency,
            count: 1,
          },
        });

        // dv360
        await Dv360.sendApi(GTM.EVENT.PURCHACE_COMPLETE_MODAL, {
          purchase: {
            value: payInfo.value,
            currency: payInfo.currency,
            transaction_id: payInfo.id,
          },
        });
        //assist
        await Assist.sendApi(GTM.EVENT.PURCHACE_COMPLETE_MODAL);
        // affiliate
        await Affiliate.sendApi(GTM.EVENT.PURCHACE_COMPLETE_MODAL, {
          userId: userInfo.userId,
          purchase: {
            value: payInfo.value,
            currency: payInfo.currency,
            transaction_id: payInfo.id,
          },
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  /**
   * loginList 쿠키 값이 있는지 체크, 없으면 생성
   * @param loginId
   * @param loginId 로그인한 id
   * @return true : loginId로 로그인 한 이력이 있을 경우
   * @return false : loginId로 로그인 한 이력이 없는 경우
   */
  const login = {
    check: (loginId: string) => {
      const loginCookie = Cookies.get('login') || '';

      if (loginCookie === '') {
        const newList = [loginId];
        login.set(newList);
        return false;
      }

      const list = JSON.parse(loginCookie);
      const isOlderVersion = list === 1;
      if (isOlderVersion) {
        const newList = [loginId];
        login.set(newList);
        return true;
      }

      if (
        list.find((id: string) => {
          return id === loginId;
        })
      ) {
        return true;
      } else {
        const newList = list.concat(loginId);
        login.set(newList);
        return false;
      }
    },
    set: (newList: string[]) => {
      Cookies.set('login', JSON.stringify(newList), {
        expires: getMarketingLoginCheckTime(),
      });
    },
  };

  /**
   * 파트너 코드 유입 포스트백을 위한 값
   * @returns
   */
  export const partnerCallbackPaprams = () => {
    // redTrack 매체
    const redTrackValue = RedTrack.getPaymentParams();

    if (redTrackValue) {
      return redTrackValue;
    }
  };
}
